import { BroadcastChannel } from 'broadcast-channel';
import dayjs from 'dayjs';
import Decimal from 'decimal.js';
import nzh from 'nzh';
import CryptoJS from 'crypto-js';
import { extend } from 'umi-request';

function base64Encode(str) {
  if (!str) {
    return "";
  }
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
    return String.fromCharCode(parseInt(p1, 16));
  }));
}

const base64Decode = (str) => {
  if (!str) {
    return "";
  }
  return decodeURIComponent(
    atob(str).split("").map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)).join("")
  );
};

const getCloseBc = () => new BroadcastChannel("close");
const getReloadBc = () => new BroadcastChannel("reload");
const getTabBc = () => new BroadcastChannel("tabs");
const closeHandle = () => {
  var _a, _b;
  if (window.sessionStorage.getItem("noclose") === "noclose") {
    window.sessionStorage.removeItem("noclose");
    return false;
  }
  if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
    (_a = open(location, "_self")) == null ? void 0 : _a.close();
    window.location.href = "about:blank";
    window.close();
  } else {
    window.opener = null;
    window.open("", "_self");
    window.close();
    (_b = open(location, "_self")) == null ? void 0 : _b.close();
  }
};
const closeBcListener = () => {
  getCloseBc().addEventListener("message", closeHandle);
};
const removeCloseBcListener = (document) => {
  getCloseBc().removeEventListener("message", closeHandle);
};
const reloadHandle = () => {
  window.location.reload();
};
const reloadBcListener = () => {
  getCloseBc().addEventListener("message", reloadHandle);
};
const removeReloadBcListener = () => {
  getCloseBc().removeEventListener("message", reloadHandle);
};
const tabBcPostMessage = (data) => {
  if (data && data.systemId && data.title) {
    getTabBc().postMessage(data);
  }
};

var __defProp$4 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
const platformCodeType = [
  { label: "\u53EF\u4FE1\u5DE5\u7A0B\u5E73\u53F0", value: "1" },
  { label: "\u4F9B\u5E94\u94FE\u5E73\u53F0", value: "2" }
];
const channelType = [
  { label: "PC", value: 1 },
  { label: "APP", value: 2 }
];
const artType = [
  { label: "\u6587\u7AE0", value: 1 },
  { label: "\u89C6\u9891", value: 2 }
];
const ossDevSystemType = [
  { label: "\u5E73\u53F0\u5B50\u7CFB\u7EDF", value: "01" },
  { label: "\u5E94\u7528\u5B50\u7CFB\u7EDF", value: "02" }
];
const cronDateType = [
  { label: "\u5E74\u606F", value: 2 },
  { label: "\u65E5\u606F", value: 1 }
];
const orderStatusType = [
  { label: "\u5168\u90E8", value: -1, status: "default" },
  { label: "\u8349\u7A3F", value: 1, status: "default" },
  { label: "\u5F85\u63A5\u6536", value: 12, status: "processing" },
  { label: "\u5F85\u63A5\u53D7", value: 57, status: "processing" },
  { label: "\u5F85\u63A5\u5355", value: 55, status: "processing" },
  { label: "\u5DF2\u63A5\u6536", value: 17, status: "success" },
  { label: "\u5BA1\u6279\u4E2D", value: 2, status: "processing" },
  { label: "\u5185\u90E8\u5BA1\u6279\u4E2D", value: 13, status: "processing" },
  { label: "\u5BA1\u6279\u62D2\u7EDD", value: 4, status: "error" },
  { label: "\u5185\u90E8\u5BA1\u6279\u62D2\u7EDD", value: 15, status: "error" },
  { label: "\u5DF2\u9000\u56DE", value: 7, status: "error" },
  { label: "\u5185\u90E8\u5BA1\u6279\u9000\u56DE", value: 16, status: "error" },
  { label: "\u5185\u90E8\u5BA1\u6279\u901A\u8FC7", value: 14, status: "success" },
  { label: "\u5DF2\u4ED8\u6B3E", value: 6, status: "success" },
  { label: "\u5F85\u5BF9\u65B9\u63A5\u6536", value: 63, status: "processing" },
  { label: "\u672A\u5F00\u59CB", value: 11, status: "error" },
  { label: "\u5BF9\u65B9\u5BA1\u6279\u4E2D", value: 62, status: "processing" },
  { label: "\u5DF2\u9000\u56DE", value: 20, status: "success" },
  { label: "\u5F85\u53D1\u5E03", value: 51, status: "processing" },
  { label: "\u8FDB\u884C\u4E2D", value: 60, status: "processing" },
  { label: "\u672A\u751F\u6548", value: 53, status: "error" },
  { label: "\u5DF2\u9000\u56DE", value: 56, status: "error" },
  { label: "\u5DF2\u4F5C\u5E9F", value: 58, status: "error" },
  { label: "\u5DF2\u7ED3\u675F", value: 61, status: "error" },
  { label: "\u5DF2\u53D1\u5E03", value: 52, status: "success" },
  { label: "\u5BA1\u6279\u901A\u8FC7", value: 3, status: "success" },
  { label: "\u5DF2\u751F\u6548", value: 54, status: "success" },
  { label: "\u5DF2\u63A5\u53D7", value: 59, status: "success" },
  { label: "\u5F85\u786E\u8BA4", value: 64, status: "processing" },
  { label: "\u5DF2\u786E\u8BA4", value: 65, status: "success" },
  { label: "\u5F85\u5BF9\u65B9\u786E\u8BA4", value: 66, status: "processing" },
  { label: "\u5DF2\u4F5C\u5E9F", value: 67, status: "error" }
].map((m, index) => {
  return __spreadProps$3(__spreadValues$4({}, m), {
    sort: index + 1
  });
});
const orderStatusTypeMap = orderStatusType.reduce(
  (memo, cur) => {
    memo[cur.value] = cur;
    return memo;
  },
  {}
);
function findConstantLabel(value, constantType, labelKey = "label") {
  if (value === void 0) {
    return "";
  }
  if (value == null) {
    return "";
  }
  let find;
  if (Array.isArray(constantType)) {
    find = constantType.find((e) => e.value == value);
  } else {
    find = orderStatusTypeMap[value];
  }
  return find ? find[labelKey] : "";
}
function findConstant(value, constantType) {
  if (value === void 0) {
    return "";
  }
  if (value == null) {
    return "";
  }
  let find;
  if (Array.isArray(constantType)) {
    find = constantType.find((e) => e.value == value);
  } else {
    find = orderStatusTypeMap[value];
  }
  return find || null;
}
const formatOrderStatus = (value) => {
  return findConstantLabel(value, orderStatusTypeMap);
};
const getBadgeStatus = (value) => {
  return findConstantLabel(value, orderStatusTypeMap, "status") || "default";
};
const constantOptions2Enum = (options = []) => {
  return options.reduce((memo, cur) => {
    memo[cur.value] = __spreadProps$3(__spreadValues$4({}, cur), {
      text: cur.label
    });
    return memo;
  }, {});
};
var orderStatusTypeEnum = /* @__PURE__ */ ((orderStatusTypeEnum2) => {
  orderStatusTypeEnum2[orderStatusTypeEnum2["all"] = -1] = "all";
  orderStatusTypeEnum2[orderStatusTypeEnum2["draft"] = 1] = "draft";
  orderStatusTypeEnum2[orderStatusTypeEnum2["approval"] = 2] = "approval";
  orderStatusTypeEnum2[orderStatusTypeEnum2["approved"] = 3] = "approved";
  orderStatusTypeEnum2[orderStatusTypeEnum2["approvalDenied"] = 4] = "approvalDenied";
  orderStatusTypeEnum2[orderStatusTypeEnum2["paid"] = 6] = "paid";
  orderStatusTypeEnum2[orderStatusTypeEnum2["returned"] = 7] = "returned";
  orderStatusTypeEnum2[orderStatusTypeEnum2["notStarted"] = 11] = "notStarted";
  orderStatusTypeEnum2[orderStatusTypeEnum2["toBeReceived"] = 12] = "toBeReceived";
  orderStatusTypeEnum2[orderStatusTypeEnum2["internalApproval"] = 13] = "internalApproval";
  orderStatusTypeEnum2[orderStatusTypeEnum2["internalApprovalPassed"] = 14] = "internalApprovalPassed";
  orderStatusTypeEnum2[orderStatusTypeEnum2["internalApprovalDenied"] = 15] = "internalApprovalDenied";
  orderStatusTypeEnum2[orderStatusTypeEnum2["internalApprovalReturned"] = 16] = "internalApprovalReturned";
  orderStatusTypeEnum2[orderStatusTypeEnum2["received"] = 17] = "received";
  orderStatusTypeEnum2[orderStatusTypeEnum2["returned20"] = 20] = "returned20";
  orderStatusTypeEnum2[orderStatusTypeEnum2["toBePublished"] = 51] = "toBePublished";
  orderStatusTypeEnum2[orderStatusTypeEnum2["published"] = 52] = "published";
  orderStatusTypeEnum2[orderStatusTypeEnum2["notValid"] = 53] = "notValid";
  orderStatusTypeEnum2[orderStatusTypeEnum2["effective"] = 54] = "effective";
  orderStatusTypeEnum2[orderStatusTypeEnum2["pendingOrder"] = 55] = "pendingOrder";
  orderStatusTypeEnum2[orderStatusTypeEnum2["returned56"] = 56] = "returned56";
  orderStatusTypeEnum2[orderStatusTypeEnum2["pending"] = 57] = "pending";
  orderStatusTypeEnum2[orderStatusTypeEnum2["obsolete"] = 58] = "obsolete";
  orderStatusTypeEnum2[orderStatusTypeEnum2["accepted"] = 59] = "accepted";
  orderStatusTypeEnum2[orderStatusTypeEnum2["inProgress"] = 60] = "inProgress";
  orderStatusTypeEnum2[orderStatusTypeEnum2["finished"] = 61] = "finished";
  orderStatusTypeEnum2[orderStatusTypeEnum2["approvedByTheOtherParty"] = 62] = "approvedByTheOtherParty";
  orderStatusTypeEnum2[orderStatusTypeEnum2["toBeReceivedByTheOtherParty"] = 63] = "toBeReceivedByTheOtherParty";
  orderStatusTypeEnum2[orderStatusTypeEnum2["toBeConfirmed"] = 64] = "toBeConfirmed";
  orderStatusTypeEnum2[orderStatusTypeEnum2["confirmed"] = 65] = "confirmed";
  orderStatusTypeEnum2[orderStatusTypeEnum2["toBeConfimByTheOtherParty"] = 66] = "toBeConfimByTheOtherParty";
  orderStatusTypeEnum2[orderStatusTypeEnum2["inClose"] = 67] = "inClose";
  return orderStatusTypeEnum2;
})(orderStatusTypeEnum || {});
const busType = [
  { label: "\u6807\u51C6\u91C7\u9500", value: 1 },
  { label: "\u8D38\u6613\u91C7\u9500", value: 2 },
  { label: "\u9500\u552E\u8BA1\u8D39", value: 3 },
  { label: "\u9884\u5145\u503C", value: 4 },
  { label: "\u5145\u503C\u4ED8\u6B3E", value: 5 }
];
const shipmentsTypeType = [
  { label: "\u81EA\u63D0", value: 1 },
  { label: "\u9001\u8D27\u4E0A\u95E8", value: 2 },
  { label: "\u7269\u6D41", value: 3 }
];
var handleTypeEnum = /* @__PURE__ */ ((handleTypeEnum2) => {
  handleTypeEnum2[handleTypeEnum2["save"] = 1] = "save";
  handleTypeEnum2[handleTypeEnum2["submit"] = 2] = "submit";
  return handleTypeEnum2;
})(handleTypeEnum || {});
var unitTypeEnum = /* @__PURE__ */ ((unitTypeEnum2) => {
  unitTypeEnum2[unitTypeEnum2["constructionUnit"] = 1] = "constructionUnit";
  unitTypeEnum2[unitTypeEnum2["generalContractor"] = 2] = "generalContractor";
  unitTypeEnum2[unitTypeEnum2["designUnit"] = 3] = "designUnit";
  unitTypeEnum2[unitTypeEnum2["supervisor"] = 4] = "supervisor";
  unitTypeEnum2[unitTypeEnum2["surveyUnit"] = 5] = "surveyUnit";
  unitTypeEnum2[unitTypeEnum2["commercialConcreteSupplier"] = 6] = "commercialConcreteSupplier";
  unitTypeEnum2[unitTypeEnum2["testingUnit"] = 7] = "testingUnit";
  unitTypeEnum2[unitTypeEnum2["supplier"] = 8] = "supplier";
  unitTypeEnum2[unitTypeEnum2["subcontractor"] = 9] = "subcontractor";
  unitTypeEnum2[unitTypeEnum2["laborCompany"] = 10] = "laborCompany";
  unitTypeEnum2[unitTypeEnum2["thirdPartyService"] = 11] = "thirdPartyService";
  unitTypeEnum2[unitTypeEnum2["other"] = 12] = "other";
  unitTypeEnum2[unitTypeEnum2["constructionAgent"] = 13] = "constructionAgent";
  unitTypeEnum2[unitTypeEnum2["waterConstructionUnit"] = 14] = "waterConstructionUnit";
  unitTypeEnum2[unitTypeEnum2["gasConstructionUnit"] = 15] = "gasConstructionUnit";
  unitTypeEnum2[unitTypeEnum2["powerConstructionUnit"] = 16] = "powerConstructionUnit";
  return unitTypeEnum2;
})(unitTypeEnum || {});

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
const materialFieldFormat = (baseObj) => {
  const newObj = __spreadValues$3({}, baseObj);
  if (baseObj.code) {
    newObj["materialCode"] = baseObj.code;
  }
  if (baseObj.name) {
    newObj["materialName"] = baseObj.name;
  }
  if (baseObj.spec || baseObj.specifications) {
    newObj["materialSpec"] = baseObj.spec || baseObj.specifications;
  }
  if (baseObj.category || baseObj.categoryDesc) {
    newObj["materialCategory"] = baseObj.category || baseObj.categoryDesc;
  }
  if (baseObj.brand || baseObj.brandDesc) {
    newObj["materialBrand"] = baseObj.brand || baseObj.brandDesc;
  }
  if (baseObj.batchCodeFlag) {
    newObj["materialBatchCodeFlag"] = baseObj.batchCodeFlag;
  }
  if (baseObj.batchCodeAutoFlag) {
    newObj["materialBatchCodeAutoFlag"] = baseObj.batchCodeAutoFlag;
  }
  if (baseObj.seqCodeFlag) {
    newObj["materialSeqCodeFlag"] = baseObj.seqCodeFlag;
  }
  if (baseObj.unit) {
    newObj["materialUnit"] = baseObj.unit;
  }
  if (baseObj.typeName) {
    newObj["materialTypeName"] = baseObj.typeName;
  }
  if (baseObj.typeId) {
    newObj["materialTypeId"] = baseObj.materialTypeId;
  }
  if (baseObj.typeCode) {
    newObj["materialTypeCode"] = baseObj.typeCode;
  }
  newObj.factoryTime = newObj.factoryTime ? newObj.factoryTime : null;
  return newObj;
};

function dateFormatBase(text, template = "YYYY-MM-DD") {
  var _a;
  if (!text) {
    return "--";
  }
  if (typeof text === "object") {
    text = (_a = text == null ? void 0 : text.props) == null ? void 0 : _a.children;
  }
  if (!text) {
    return "--";
  }
  if (typeof text === "string") {
    text = Number(text);
  }
  return dayjs(text).format(template);
}
function dateFormat(date) {
  return dateFormatBase(date);
}
function timeFormat(date) {
  return dateFormatBase(date, "YYYY-MM-DD HH:mm:ss");
}
const calculateDaysBetween = (startDate, endDate, unit = "day") => {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  return end.diff(start, "day");
};

function getCompanyId() {
  const userInfoObj = JSON.parse(sessionStorage.getItem("USER_INFO") || "{}");
  return userInfoObj.defaultCompId;
}
function getScmUserInfo() {
  const userInfoObj = JSON.parse(sessionStorage.getItem("USER_INFO") || "{}");
  return userInfoObj;
}

function roundNumber(num, decimalPlaces, needTrim = true) {
  const factor = new Decimal(num);
  let fixedString = factor.toFixed(decimalPlaces, Decimal.ROUND_HALF_CEIL).toString();
  if (!needTrim) {
    return fixedString;
  } else {
    while (fixedString.includes(".") && (fixedString.endsWith("0") || fixedString.endsWith("."))) {
      fixedString = fixedString.slice(0, -1);
    }
    return fixedString;
  }
}

const parseMoney = (money, fractionDigits = -1, needRegExp = true, needTrim = true) => {
  if (!money) {
    return "0";
  }
  if (typeof money !== "string") {
    money = String(money);
  }
  const isNeedFixed = fractionDigits && fractionDigits >= 0;
  let moneyFixed = money;
  if (isNeedFixed) {
    moneyFixed = roundNumber(money, fractionDigits, needTrim);
  }
  if (!needRegExp) {
    return moneyFixed;
  }
  const isNegativeNumber = moneyFixed[0] == "-";
  if (!isNegativeNumber) {
    return moneyFixed.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return "-" + moneyFixed.slice(1).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

const money2Zh = (number, type = "upper") => {
  if (!number) {
    return "\u96F6";
  }
  if (typeof number == "string") {
    number = Number(number);
  }
  let isStZero = false;
  if (number < 0) {
    isStZero = true;
    number = Math.abs(+number);
  }
  const confs = {
    lower: {
      num: ["\u96F6", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D"],
      unit: ["", "\u5341", "\u767E", "\u5343", "\u4E07"],
      level: ["", "\u4E07", "\u4EBF"]
    },
    upper: {
      num: ["\u96F6", "\u58F9", "\u8D30", "\u53C1", "\u8086", "\u4F0D", "\u9646", "\u67D2", "\u634C", "\u7396"],
      unit: ["", "\u62FE", "\u4F70", "\u4EDF"],
      level: ["", "\u4E07", "\u4EBF"]
    },
    decimal: {
      unit: ["\u5206", "\u89D2"]
    },
    maxNumber: 99999999999999e-2
  };
  if (typeof number === "string") {
    number = Number(number);
  }
  if (number > confs.maxNumber) {
    console.error(
      `The maxNumber is ${confs.maxNumber}. ${number} is bigger than it!`
    );
    return false;
  }
  const conf = confs[type];
  const numbers = String(number.toFixed(2)).split(".");
  const integer = numbers[0].split("");
  const decimal = Number(numbers[1]) === 0 ? [] : numbers[1].split("");
  const levels = integer.reverse().reduce((pre, item, idx) => {
    let level = pre[0] && pre[0].length < 4 ? pre[0] : [];
    let value = item === "0" ? conf.num[item] : conf.num[item] + conf.unit[idx % 4];
    level.unshift(value);
    if (level.length === 1) {
      pre.unshift(level);
    } else {
      pre[0] = level;
    }
    return pre;
  }, []);
  const _integer = levels.reduce((pre, item, idx) => {
    let _level = conf.level[levels.length - idx - 1];
    let _item = item.join("").replace(/(零)\1+/g, "$1");
    if (_item === "\u96F6") {
      _item = "";
      _level = "";
    } else if (_item[_item.length - 1] === "\u96F6") {
      _item = _item.slice(0, _item.length - 1);
    }
    return pre + _item + _level;
  }, "");
  let _decimal = decimal.map((item, idx) => {
    const unit = confs.decimal.unit;
    const _unit = item !== "0" ? unit[unit.length - idx - 1] : "";
    return `${conf.num[item]}${_unit}`;
  }).join("");
  return `${isStZero ? "\u8D1F" : ""}${_integer}\u5143` + (_decimal || "\u6574");
};

const Nzh = nzh.cn;
const toMoneyCnEncode = (num) => {
  return Nzh.toMoney(num);
};
const toMoneyEncode = (num) => {
  return toMoneyCnEncode(num).replace("\u4EBA\u6C11\u5E01", "");
};
const formatMoneyEncode = (num) => {
  return toMoneyCnEncode(num).replace("\u4EBA\u6C11\u5E01", "(\u4EBA\u6C11\u5E01) ");
};
function toFixedNumber(num, decimalPlaces = 2, trim = true) {
  const factor = new Decimal(num);
  let fixedString = factor.toFixed(decimalPlaces, Decimal.ROUND_HALF_CEIL).toString();
  if (!trim) {
    return fixedString;
  } else {
    while (fixedString.includes(".") && (fixedString.endsWith("0") || fixedString.endsWith("."))) {
      fixedString = fixedString.slice(0, -1);
    }
    return fixedString;
  }
}
const formatToThousands = (num, minimumFractionDigits = 2) => {
  const tempNumStr = (+num || 0).toLocaleString("zh-CN", {
    minimumFractionDigits,
    maximumFractionDigits: minimumFractionDigits
  });
  const splitIndex = tempNumStr.indexOf(".") + 3;
  const preNumStr = tempNumStr.substring(0, splitIndex);
  const numStr = (preNumStr + tempNumStr.substring(splitIndex).replace(/(0+)$/, "")).replace(
    /\.$/,
    ""
  );
  return numStr.includes(".") ? numStr : `${numStr}.00`;
};
const addMoneyPrefix = (num, prefix = "\uFFE5") => {
  return num === void 0 || num === null || num === "" ? "" : `${prefix}${num}`;
};
const numberAdd = (a, b) => {
  return Decimal.add(a || 0, b || 0).toString();
};
const numberSub = (a, b) => {
  return Decimal.sub(a || 0, b || 0).toString();
};
const numberMul = (a, b) => {
  return Decimal.mul(a || 0, b || 0).toString();
};
const numberDiv = (a, b) => {
  return Decimal.div(a || 0, b || 0).toString();
};

const yuan2Wy = (money = 0, { needRegExp = true, fractionDigits = 1 }) => {
  if (!money) {
    return "0.0";
  }
  const ey = Decimal.div(money, 1e4).toFixed(fractionDigits).toString();
  if (needRegExp) {
    return parseMoney(ey);
  } else {
    return ey;
  }
};
const yuan2Ey = (money = 0, { needRegExp = true, fractionDigits = 1 }) => {
  if (!money) {
    return "0.0";
  }
  const ey = Decimal.div(money, 1e8).toFixed(fractionDigits).toString();
  if (needRegExp) {
    return parseMoney(ey);
  } else {
    return ey;
  }
};

const number2MonthText = (index) => {
  const textArr = ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u5341\u4E00", "\u5341\u4E8C"];
  if (index === 0) {
    return "\u672C\u6708";
  }
  return `\u7B2C${textArr[index]}\u4E2A\u6708`;
};

const regexp = {
  email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  url: /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,
  number: /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/,
  isZipCode: /^[0-9]{6}$/,
  phone: /^1[3456789]\d{9}$/,
  character: /[`()\-+=<>:"{}|,.\/;'\\[\]·￥……（）——\-+={}|《》？：“”【】、；‘'，。、]/,
  charAll: /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/,
  idCard: /^([1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2})$/,
  isAccount: /^\w+$/,
  integer: /^([1-9]\d*|[0]{1,1})$/,
  isUppercaseLetter: /[A-Z]/,
  isLowercaseLetter: /[a-z]/,
  isNumberHas: /\d+/,
  isHasStr: /(?=.*[!@#$%^&*,\.])/,
  isHasStr2: /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
  isChinese: /[\u4e00-\u9fa5]+/,
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9|^\w\s]).{8,}$/,
  isUppercaseLetterAndNumber: /^[A-Z][A-Z0-9]*$/,
  isUppercaseLetterAndNumberStr: /^[A-Z][A-Z0-9\-/]*$/,
  certRegNo: /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/
};

function isEmpty(value) {
  return !value || value === 0 || value === "0";
}
function isNotEmpty(value) {
  return !isEmpty(value);
}

const constant = {
  access_token: "ACCESS_TOKEN",
  refresh_token: "REFRESH_TOKEN",
  expires_in: "EXPIRES_IN",
  token_expires_time: "TOKEN_EXPIRES_TIME",
  user_info: "USER_INFO",
  user_name: "USER_NAME",
  sessionId: "sessionId"
};
const host = window.location.origin;
const fp = window.sessionStorage.getItem("fp") || "2";
const authDelToken = () => {
  sessionStorage.removeItem(constant.access_token);
  sessionStorage.removeItem(constant.refresh_token);
  sessionStorage.removeItem(constant.expires_in);
  sessionStorage.removeItem(constant.token_expires_time);
  sessionStorage.removeItem(constant.user_info);
  sessionStorage.removeItem(constant.user_name);
  sessionStorage.removeItem("selectedKeys");
  sessionStorage.removeItem("openKeys");
  localStorage.removeItem("dict_code");
};
const authLogout = (e, s = "") => {
  let userInfo = sessionStorage.getItem(constant.user_info);
  if (userInfo) {
    userInfo = JSON.parse(userInfo);
  }
  const userId = userInfo && userInfo.id ? userInfo.id : s;
  authDelToken();
  const baseURL = host;
  const aUrl = baseURL + "/auth";
  if (e && e === 1) {
    window.location.href = aUrl + `/logout?ct=1&userId=${userId}&fp=${fp}`;
  } else {
    if (window.opener && window.opener != null) {
      window.opener = null;
      window.close();
      window.location.href = aUrl + `/logout?ct=1&userId=${userId}&fp=${fp}`;
    } else {
      window.location.href = aUrl + `/logout?ct=1&userId=${userId}&fp=${fp}`;
    }
  }
};

const getFileRatio = async (file, accept = ".jpg,.jpeg,.png") => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const index = file.name.lastIndexOf(".");
    if (index < 0 || !accept.split(",").includes(file.name.substring(index))) {
      reject(`\u8BF7\u4F20\u5165 ${accept} \u683C\u5F0F\u7684\u56FE\u7247`);
    }
    reader.onload = () => {
      if (reader.readyState == 2) {
        const img = new Image();
        img.src = reader.result;
        img.onload = () => {
          resolve({
            width: img.width,
            height: img.height
          });
        };
      }
    };
  });
};

function setGlobalSessionMsg() {
  const searchParams = new URLSearchParams(window.location.search);
  const ACCESS_TOKEN = searchParams.get("ACCESS_TOKEN") || "";
  const fp = searchParams.get("fp") || "";
  const ct = searchParams.get("ct") || "";
  const pt = searchParams.get("pt") || "";
  if (ACCESS_TOKEN) {
    sessionStorage.setItem("ACCESS_TOKEN", ACCESS_TOKEN);
  }
  if (ct) {
    sessionStorage.setItem("ct", ct);
  }
  if (pt) {
    sessionStorage.setItem("pt", pt);
  }
  if (fp) {
    localStorage.setItem("fp", fp);
  }
}

var __defProp$2 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
function emptyAction(...args) {
}
const devShared = {};
class Actions {
  constructor() {
    this.actions = __spreadProps$2(__spreadValues$2({
      onGlobalStateChange: emptyAction,
      setGlobalState: emptyAction
    }, devShared), {
      permissList: [],
      permissMap: {},
      websocket: null,
      system: "",
      currentUser: {},
      Thing: null
    });
  }
  setActions(actions2) {
    this.actions = actions2;
  }
  setSystem(str) {
    this.actions.system = str;
  }
  onGlobalStateChange(...args) {
    this.actions.onGlobalStateChange(...args);
  }
  setGlobalState(...args) {
    this.actions.setGlobalState(...args);
  }
  setPermissionList(list = []) {
    this.actions.permissList = list;
    return this;
  }
  getPermissionList() {
    return this.actions.permissList || [];
  }
  getPermissionMap() {
    return this.actions.permissMap || {};
  }
  setPermissionMap(map = {}) {
    this.actions.permissMap = map;
    return this;
  }
  formatPermission() {
    const permissList = this.getPermissionList();
    const map = permissList.reduce(
      (total, current) => (total[current.action] = current.action, total),
      {}
    ) || {};
    this.setPermissionMap(map);
    return map;
  }
  checkActionMap(action) {
    const map = this.getPermissionMap();
    return map[action];
  }
  getUserInfo() {
    return this.actions.currentUser;
  }
  getWebsocket() {
    return this.actions.websocket;
  }
  setWebsocket(websocket) {
    this.actions.websocket = websocket;
    return this;
  }
  getSystem() {
    return this.actions.system;
  }
  setThing(thing) {
    this.actions.Thing = thing;
    return this;
  }
  getThing() {
    return this.actions.Thing;
  }
}
const actions = new Actions();

const checkAction = (actionOrOperate) => {
  if (typeof actionOrOperate === "undefined") {
    return true;
  }
  if (typeof actionOrOperate === "string") {
    return actions.checkActionMap(actionOrOperate);
  } else {
    return !actionOrOperate.action || actions.checkActionMap(actionOrOperate.action);
  }
};
const checkPermission = ({
  id,
  action
}, authorityModel) => {
  return checkPagePermission(id, authorityModel) && checkAction(action);
};
const checkPagePermission = (id, authorityModel) => {
  if (!authorityModel || !id) {
    return true;
  }
  return authorityModel[id] === false ? false : true;
};

const DATE_YYYY = "YYYY";
const DATE_MM = "YYYY-MM";
const DATE_DD = "YYYY-MM-DD";
const DATE_HH = "YYYY-MM-DD HH";
const DATE_mm = "YYYY-MM-DD HH:mm";
const DATE_ss = "YYYY-MM-DD HH:mm:ss";
const isEmptyDate = (time) => time && time !== "0";
const formart_YYYY = (time, empty) => isEmptyDate(time) ? dayjs(+time).format(DATE_YYYY) : empty;
const formart_MM = (time, empty) => isEmptyDate(time) ? dayjs(+time).format(DATE_MM) : empty;
const formart_DD = (time, empty) => isEmptyDate(time) ? dayjs(+time).format(DATE_DD) : empty;
const formart_HH = (time, empty) => isEmptyDate(time) ? dayjs(+time).format(DATE_HH) : empty;
const formart_mm = (time, empty) => isEmptyDate(time) ? dayjs(+time).format(DATE_mm) : empty;
const formart_ss = (time, empty) => isEmptyDate(time) ? dayjs(+time).format(DATE_ss) : empty;
const formartDateStartOf = (time) => dayjs(time).startOf("day").valueOf();
const formartDateEndOf = (time) => dayjs(time).endOf("day").valueOf();
const formartDate = (time, type, empty) => isEmptyDate(time) ? dayjs(+time).format(type) : empty;
const formatTimeRange = (times, statrKey = "createStart", endKey = "createEnd") => {
  if (!times || times.length !== 2) {
    return {};
  }
  return times[0] ? {
    [statrKey]: formartDateStartOf(times[0]),
    [endKey]: formartDateEndOf(times[1])
  } : {};
};

const ORDER_STATUS = [
  {
    label: "\u5168\u90E8",
    number: 0,
    key: -1
  },
  {
    label: "\u8349\u7A3F",
    status: "default",
    number: 0,
    key: 1
  },
  {
    label: "\u5BA1\u6279\u4E2D",
    status: "processing",
    number: 0,
    key: 2
  },
  {
    label: "\u5BA1\u6279\u901A\u8FC7",
    status: "success",
    number: 0,
    key: 3
  },
  {
    label: "\u5BA1\u6279\u62D2\u7EDD",
    status: "error",
    number: 0,
    key: 4
  },
  {
    label: "\u5DF2\u4ED8\u6B3E",
    status: "success",
    number: 0,
    key: 6
  },
  {
    label: "\u5DF2\u9000\u56DE",
    status: "error",
    number: 0,
    key: 7
  },
  {
    label: "\u672A\u5F00\u59CB",
    status: "error",
    number: 0,
    key: 11
  },
  {
    label: "\u5F85\u63A5\u6536",
    status: "processing",
    number: 0,
    key: 12
  },
  {
    label: "\u5185\u90E8\u5BA1\u6279\u4E2D",
    status: "processing",
    number: 0,
    key: 13
  },
  {
    label: "\u5185\u90E8\u5BA1\u6279\u901A\u8FC7",
    status: "success",
    number: 0,
    key: 14
  },
  {
    label: "\u5185\u90E8\u5BA1\u6279\u62D2\u7EDD",
    status: "error",
    number: 0,
    key: 15
  },
  {
    label: "\u5185\u90E8\u5BA1\u6279\u9000\u56DE",
    status: "error",
    number: 0,
    key: 16
  },
  {
    label: "\u5DF2\u63A5\u6536",
    status: "success",
    number: 0,
    key: 17
  },
  {
    label: "\u5DF2\u9000\u56DE",
    status: "success",
    number: 0,
    key: 20
  },
  {
    label: "\u5F85\u53D1\u5E03",
    status: "processing",
    number: 0,
    key: 51
  },
  {
    label: "\u5DF2\u53D1\u5E03",
    status: "success",
    number: 0,
    key: 52
  },
  {
    label: "\u672A\u751F\u6548",
    status: "error",
    number: 0,
    key: 53
  },
  {
    label: "\u5DF2\u751F\u6548",
    status: "success",
    number: 0,
    key: 54
  },
  {
    label: "\u5F85\u63A5\u5355",
    status: "processing",
    number: 0,
    key: 55
  },
  {
    label: "\u5DF2\u9000\u56DE",
    status: "error",
    number: 0,
    key: 56
  },
  {
    label: "\u5F85\u63A5\u53D7",
    status: "processing",
    number: 0,
    key: 57
  },
  {
    label: "\u5DF2\u4F5C\u5E9F",
    status: "error",
    number: 0,
    key: 58
  },
  {
    label: "\u5DF2\u63A5\u53D7",
    status: "success",
    number: 0,
    key: 59
  },
  {
    label: "\u8FDB\u884C\u4E2D",
    status: "processing",
    number: 0,
    key: 60
  },
  {
    label: "\u5DF2\u7ED3\u675F",
    status: "error",
    number: 0,
    key: 61
  },
  {
    label: "\u5BF9\u65B9\u5BA1\u6279\u4E2D",
    status: "processing",
    number: 0,
    key: 62
  },
  {
    label: "\u5F85\u5BF9\u65B9\u63A5\u6536",
    status: "processing",
    number: 0,
    key: 63
  },
  {
    label: "\u5F85\u786E\u8BA4",
    status: "processing",
    number: 0,
    key: 64
  },
  {
    label: "\u5DF2\u786E\u8BA4",
    status: "success",
    number: 0,
    key: 65
  },
  {
    label: "\u5F85\u5BF9\u65B9\u786E\u8BA4",
    status: "processing",
    number: 0,
    key: 66
  }
];
const getFlowStatus = (orderStatus) => {
  if (orderStatus === void 0) {
    return null;
  }
  return ORDER_STATUS.find((item) => item.key === orderStatus);
};
const getFlowStatusUrl = (orderStatus) => {
  const obj = getFlowStatus(orderStatus);
  return obj ? obj.label : void 0;
};

const POPUP_PARENT_NODE = {
  getPopupContainer: (node) => {
    return node.parentNode || document.body;
  }
};
const renderToTimeDD = {
  renderText: (text) => {
    return formart_DD(text);
  }
};
const columnsTransformDate = (dateStartKey, dateEndKey) => {
  return {
    transform: (value) => ({
      [dateStartKey]: formartDateStartOf(value[0]),
      [dateEndKey]: formartDateEndOf(value[1])
    })
  };
};
const renderToThousandsAndCn = {
  renderText: (text) => {
    return addMoneyPrefix(formatToThousands(+text));
  },
  align: "right"
};

const getPayTitle = (isSupplier) => isSupplier ? "\u6536\u6B3E" : "\u4ED8\u6B3E";
const getDealUnit = (dealUnit) => dealUnit === 0 ? "\u5929" : "\u4E2A\u6708";
const dealDateTypeMap = {
  1: "\u63A5\u6536\u65B9\u63A5\u6536\u65E5\u671F",
  2: "\u5F00\u7968\u65E5\u671F",
  3: "\u7CFB\u7EDF\u767B\u8BB0\u65E5\u671F"
};
const getDealRuleFirstDesc = (data, isSupplier) => {
  return `\u7ED3\u7B97\u540E${data.dealDays}${getDealUnit(data.dealUnit)}${getPayTitle(isSupplier)}`;
};
const getDealRuleSecondDesc = (data, isSupplier) => {
  return `\u6BCF\u4E2A\u6708${data.dealDays}\u65E5${getPayTitle(isSupplier)}`;
};
const getDealRuleThirdDesc = (data, isSupplier) => {
  return `\u6536\u8D27\u540E${data.dealDays}${getDealUnit(data.dealUnit)}${getPayTitle(isSupplier)}`;
};
const getDealRuleFourDesc = (data, isSupplier) => {
  return `\u6536\u5230\u53D1\u7968 (${dealDateTypeMap[data.dealDateType] || ""}) \u540E${data.dealDays}${getDealUnit(
    data.dealUnit
  )}${getPayTitle(isSupplier)}`;
};
const getDealRuleFiveDesc = (data, isSupplier) => {
  return `${formart_DD(data.dealPayDate)}${getPayTitle(isSupplier)}`;
};
const getDealRuleDescMap = {
  1: getDealRuleFirstDesc,
  2: getDealRuleSecondDesc,
  3: getDealRuleThirdDesc,
  4: getDealRuleFourDesc,
  5: getDealRuleFiveDesc
};
const getDealRuleDesc = (data, isSupplier) => {
  const { dealRule } = data || {};
  if (!dealRule) {
    return "";
  }
  return data.dealRule && getDealRuleDescMap[data.dealRule] ? getDealRuleDescMap[data.dealRule](data, isSupplier) : "";
};
const getdealUnitType = (dealUnit) => dealUnit === 0 ? "day" : "month";
const getDealRuleDate = (data) => {
  const { dealRule, dealDays, dealPayDate, dealUnit } = data || {};
  if (!dealRule) {
    return "";
  }
  return dayjs(dealPayDate).add(dealDays, getdealUnitType(dealUnit || 0)).valueOf();
};

function saveAsFile(blob, filename) {
  let link = document.createElement("a");
  let body = document.querySelector("body");
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  link.style.display = "none";
  body == null ? void 0 : body.appendChild(link);
  link.click();
  body == null ? void 0 : body.removeChild(link);
  window.URL.revokeObjectURL(link.href);
}
function downloadFile(url, filename) {
  getFileBlob(url, function(blob) {
    saveAsFile(blob, filename);
  });
}
function getFileBlob(url, cb) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function() {
    if (xhr.status === 200) {
      cb(xhr.response);
    }
  };
  xhr.send();
}

var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const request = extend({ maxCache: 10 });
const getErrMap = (message) => ({
  550: {
    type: "error",
    message
  },
  502: {
    type: "error",
    message: "\u670D\u52A1\u5668\u65E0\u54CD\u5E94"
  },
  500: {
    type: "error",
    message: message || "\u670D\u52A1\u5668\u5185\u90E8\u9519\u8BEF"
  },
  404: {
    type: "error",
    message: "\u672A\u627E\u5230\u8FDC\u7A0B\u670D\u52A1\u5668"
  },
  403: {
    type: "error",
    message: "\u6CA1\u6709\u6743\u9650\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u6388\u6743"
  },
  401: {
    type: "warning",
    message: "\u7528\u6237\u8BA4\u8BC1\u5931\u8D25\uFF0C\u8BF7\u91CD\u65B0\u767B\u9646"
  }
});
const getRequestHeader = (options) => {
  const fpVal = localStorage.getItem("fp");
  const headers = {};
  headers.fp = fpVal;
  headers.pt = sessionStorage.getItem("pt") || "1";
  headers.ct = sessionStorage.getItem("ct") || "1";
  const systemId = sessionStorage.getItem("systemId");
  const _a = options, { headers: pHeaders } = _a, restOptions = __objRest(_a, ["headers"]);
  if (systemId) {
    headers["system-id"] = systemId;
  }
  if (sessionStorage.getItem("ACCESS_TOKEN")) {
    headers.Authorization = `Bearer ${sessionStorage.getItem("ACCESS_TOKEN")}`;
  }
  const _headers = __spreadValues$1(__spreadValues$1({}, headers), pHeaders);
  const _systemId = _headers["system-id"];
  if (_systemId === void 0 || _systemId === null || _systemId === "" || _systemId === "undefined" || _systemId === "null" || _systemId === "NaN") {
    delete _headers["system-id"];
  }
  return __spreadValues$1({
    headers: _headers
  }, restOptions);
};
request.interceptors.request.use((url, options) => {
  const _a = getRequestHeader(options), { headers } = _a, restOptions = __objRest(_a, ["headers"]);
  return {
    url,
    options: __spreadProps$1(__spreadValues$1({
      redirect: "follow"
    }, restOptions), {
      headers
    })
  };
});
request.interceptors.response.use(
  async (response, options) => {
    return new Promise(async (resolve, reject) => {
      var _a;
      if (response.status >= 200 && response.status < 400) {
        const responseHeaders = (_a = options == null ? void 0 : options.responseHeaders) != null ? _a : [];
        if (options.responseType === "blob") {
          resolve(response);
          return;
        }
        const res = await response.clone().json();
        const { code, message, data: result } = res || {};
        if (code !== 200) {
          reject(res);
        }
        const access_token = response.headers.get("access_token");
        if (access_token) {
          const data = JSON.parse(decodeURIComponent(access_token));
          sessionStorage.setItem("ACCESS_TOKEN", data.access_token);
          sessionStorage.setItem("USER_INFO", JSON.stringify(data.user_info));
          sessionStorage.setItem("USER_NAME", data.user_info.name);
          sessionStorage.setItem("EXPIRES_IN", data.expires_in);
          sessionStorage.setItem("REFRESH_TOKEN", data.refresh_token);
          sessionStorage.setItem("sessionId", data.refresh_token);
          localStorage.setItem(
            "storeSessionData",
            JSON.stringify({
              userInfo: data.user_info,
              token: data.access_token
            })
          );
        }
        if (responseHeaders == null ? void 0 : responseHeaders.length) {
          const getHeaders = responseHeaders.reduce((hs, key) => {
            return __spreadProps$1(__spreadValues$1({}, hs), { [key]: response.headers.get(key) });
          }, {});
          resolve(__spreadProps$1(__spreadValues$1({}, res), {
            responseHeaders: getHeaders
          }));
          return;
        }
        resolve(res);
      } else {
        const res = response.clone().json();
        reject(res);
      }
    });
  },
  { global: false }
);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const _appId = "55cHKgNTOJWhODaJ1m9678";
const _appSecret = "gNTOJWhODaJ1m9678PD0LWHK2KTic";
function uuid() {
  const hashTable = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
  ];
  const uuid2 = [];
  for (let i = 0; i < 35; i++) {
    if (i === 7 || i === 12 || i === 17 || i === 22)
      uuid2[i] = "-";
    else
      uuid2[i] = hashTable[Math.floor(Math.random() * hashTable.length - 1)];
  }
  return uuid2.join("");
}
function getBaeSignHeaders({
  sign,
  date,
  nonce,
  header
}) {
  return __spreadValues({
    "OPEN-SIGNATURE": sign,
    "x-wisdaas-date": date,
    "x-wisdaas-request-id": nonce
  }, header);
}
const signRequest = (sign) => {
  const appId = (sign == null ? void 0 : sign.appId) || _appId;
  const appSecret = (sign == null ? void 0 : sign.appSecret) || _appSecret;
  function getSignStr(stringToSign) {
    const hash = CryptoJS.HmacSHA256(stringToSign, appSecret);
    const b64 = CryptoJS.enc.Base64.stringify(hash);
    const sign2 = `WISDAAS-V2 ${appId}:${b64}`;
    return sign2;
  }
  function signWithGet(apiUrl, options) {
    const { params } = options || {};
    const date = new Date().getTime();
    const nonce = uuid();
    const requestParams = [];
    if (params) {
      const keys = Object.keys(params);
      keys == null ? void 0 : keys.forEach((key) => requestParams.push(`${key}=${params[key]}`));
    }
    requestParams.sort();
    const reqParamsStr = requestParams.length > 0 ? `?${requestParams.join("&")}` : "";
    const stringToSign = `GET
{}
application/json;charset=UTF-8
${date}
x-wisdaas-request-id:${nonce}
${apiUrl}${reqParamsStr}`;
    const sign2 = getSignStr(stringToSign);
    const header = getBaeSignHeaders({
      sign: sign2,
      date,
      nonce,
      header: { "content-type": "application/json;charset=UTF-8" }
    });
    return header;
  }
  function signWithPostImage(apiUrl, options) {
    const date = new Date().getTime();
    const nonce = uuid();
    const stringToSign = `POST
{}

${date}
x-wisdaas-request-id:${nonce}
${apiUrl}`;
    const sign2 = getSignStr(stringToSign);
    const header = getBaeSignHeaders({
      sign: sign2,
      date,
      nonce,
      header: { "Content-MD5": "{}" }
    });
    return header;
  }
  function signWithPost(apiUrl, options) {
    const { data: _data } = options || {};
    const data = JSON.stringify(_data);
    const content = CryptoJS.enc.Base64.stringify(CryptoJS.MD5(data));
    const date = new Date().getTime();
    const nonce = uuid();
    const stringToSign = `POST
${content}
application/json;charset=UTF-8
${date}
x-wisdaas-request-id:${nonce}
${apiUrl}`;
    const sign2 = getSignStr(stringToSign);
    const header = getBaeSignHeaders({
      sign: sign2,
      date,
      nonce,
      header: { "Content-MD5": content, accept: "*/*" }
    });
    return header;
  }
  const getHeaders = (method, apiUrl) => {
    if (apiUrl.includes("upload")) {
      return {
        headerFn: signWithPostImage,
        isUpload: true
      };
    }
    let headerFn = method === "GET" || method === "get" || method === "DELETE" || method === "delete" ? signWithGet : signWithPost;
    return {
      headerFn,
      isUpload: false
    };
  };
  return (apiUrl, options) => {
    return new Promise((resolve, reject) => {
      const { method } = options || {};
      const { headerFn, isUpload } = getHeaders(method, apiUrl);
      const header = headerFn ? headerFn(apiUrl, options) : {};
      return request(apiUrl, __spreadProps(__spreadValues({}, options), {
        headers: __spreadValues(__spreadValues({}, header), options.headers)
      })).then((res) => {
        if (isUpload) {
          return resolve(res);
        }
        const { code, data, message } = res;
        if (code == 200) {
          resolve(data);
        } else {
          reject(__spreadValues({}, res));
        }
      }).catch((err) => {
        reject(err);
      });
    });
  };
};

function isLogin() {
  if (sessionStorage.getItem("ACCESS_TOKEN")) {
    return true;
  }
  return false;
}
function createLoginRequest(sign, loginFun) {
  return (loginFun ? loginFun() : isLogin()) ? request : signRequest(sign);
}

export { DATE_DD, DATE_HH, DATE_MM, DATE_YYYY, DATE_mm, DATE_ss, POPUP_PARENT_NODE, actions, addMoneyPrefix, artType, authDelToken, authLogout, base64Decode, base64Encode, busType, calculateDaysBetween, channelType, checkAction, checkPagePermission, checkPermission, closeBcListener, columnsTransformDate, constantOptions2Enum, createLoginRequest, cronDateType, dateFormat, dateFormatBase, downloadFile, findConstant, findConstantLabel, formartDate, formartDateEndOf, formartDateStartOf, formart_DD, formart_HH, formart_MM, formart_YYYY, formart_mm, formart_ss, formatMoneyEncode, formatOrderStatus, formatTimeRange, formatToThousands, getBadgeStatus, getCloseBc, getCompanyId, getDealRuleDate, getDealRuleDesc, getErrMap, getFileBlob, getFileRatio, getFlowStatus, getFlowStatusUrl, getPayTitle, getReloadBc, getRequestHeader, getScmUserInfo, getTabBc, getdealUnitType, handleTypeEnum, isEmpty, isLogin, isNotEmpty, materialFieldFormat, money2Zh, number2MonthText, numberAdd, numberDiv, numberMul, numberSub, orderStatusType, orderStatusTypeEnum, orderStatusTypeMap, ossDevSystemType, parseMoney, platformCodeType, regexp, reloadBcListener, removeCloseBcListener, removeReloadBcListener, renderToThousandsAndCn, renderToTimeDD, request, roundNumber, saveAsFile, setGlobalSessionMsg, shipmentsTypeType, signRequest, tabBcPostMessage, timeFormat, toFixedNumber, toMoneyCnEncode, toMoneyEncode, unitTypeEnum, yuan2Ey, yuan2Wy };
